// export function getTenantSubdomain() {
//   const parts = window.location.hostname.split(".");
//   return parts.length > 1 ? parts[0] : "default";
// }

// export function getTenantSubdomain() {
//   try {
//     const cookie = document.cookie
//       .split("; ")
//       .find((row) => row.startsWith("token="));

//     if (!cookie) return "default";

//     const token = cookie.split("=")[1];
//     const payload = JSON.parse(atob(token.split(".")[1]));
//     console.log(payload?.tenant || "default");
//     return payload?.tenant || "default";
//   } catch (e) {
//     console.error("Error decoding token:", e);
//     return "default";
//   }
// }

export function getTenantSubdomain(onlyFromSubdomain = false) {
  try {
    // ✅ 1. Try extracting from JWT token
    const cookie = document.cookie
      .split("; ")
      .find((row) => row.startsWith("token="));

    if (cookie) {
      const token = cookie.split("=")[1];
      const payload = JSON.parse(atob(token.split(".")[1]));
      if (payload?.tenant) {
        return payload.tenant;
      }
    }
  } catch (e) {
    console.error("Error decoding token:", e);
  }

  try {
    // ✅ 2. Fallback to subdomain logic (same as your original)
    const parts = window.location.hostname.split(".");
    // console.log("Tenant Finding from ", parts);
    return parts.length > 1 ? parts[0] : "default";
  } catch (e) {
    console.error("Error parsing hostname:", e);
    return "default";
  }
}
